import { Badge } from "@/components/ui/badge";

interface CategoryBadgeProps {
  name: string;
  color: string;
  className?: string;
}

export function CategoryBadge({ name, color, className }: CategoryBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={className}
      style={{
        backgroundColor: `${color}20`,
        borderColor: color,
        color,
      }}
      aria-label={`카테고리: ${name}`}
    >
      {name}
    </Badge>
  );
}
